import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Pages
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import MagicLinkAuth from './components/Auth/MagicLinkAuth';
import ProtectedRoute from './components/Auth/ProtectedRoute';

// Onboarding
import OnboardingFlow from './pages/Onboarding/OnboardingFlow';

// Dashboard
import DashboardLayout from './components/Dashboard/DashboardLayout';
import GEODashboard from './pages/Dashboard/GEODashboard';
import SearchTerms from './pages/Dashboard/SearchTerms';
import Competitors from './pages/Dashboard/Competitors';
import Profile from './pages/Dashboard/Profile';
import Analytics from './pages/Dashboard/Analytics';
import Billing from './pages/Dashboard/Billing';
import LlmsTxtAnalyzer from './pages/Dashboard/LlmsTxtAnalyzer';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
        {/* Root route - redirect to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/magic-link" element={<MagicLinkAuth />} />
        <Route path="/complete-signin" element={<MagicLinkAuth />} />

        {/* Protected Onboarding */}
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <OnboardingFlow />
            </ProtectedRoute>
          }
        />

        {/* Protected Dashboard Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<GEODashboard />} />
          <Route path="search-terms" element={<SearchTerms />} />
          <Route path="competitors" element={<Competitors />} />
          <Route path="llms-txt" element={<LlmsTxtAnalyzer />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="profile" element={<Profile />} />
          <Route path="billing" element={<Billing />} />
        </Route>

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
